import { render, staticRenderFns } from "./home.vue?vue&type=template&id=f93fa258&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f93fa258')) {
      api.createRecord('f93fa258', component.options)
    } else {
      api.reload('f93fa258', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=f93fa258&", function () {
      api.rerender('f93fa258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/home.vue"
export default component.exports